import styled, { css } from 'styled-components'

import { BoxShadow, Colors } from 'common-constants/colors'
import { FontSize } from 'common-constants/sizes'
import { sizes } from 'components/presentational'
import { RouterLink } from 'components/presentational/link'

import { IMAGE_RATIO } from './searchPromoFunctions'
import {
  Props,
  calculatePosition,
} from '../ForeignProfile/Photos/function/calculatePosition'

export const GRID_GUTTER_WIDE = 20
export const GRID_GUTTER_SMALL = 10

const ListItemBaseCss = css`
  box-sizing: border-box;
  position: relative;
  border-radius: 10px;
  box-shadow: ${BoxShadow.Default};
  transition: box-shadow 0.3s ease;
  overflow: hidden;

  &:hover {
    box-shadow: ${BoxShadow.Strong};
    cursor: pointer;
  }
`

const PromoLayoutCss = css`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 10px;
`

export const PromoLayout = styled.div`
  ${PromoLayoutCss};
`

export const ListItemPromoRouterLink = RouterLink

/**
 * Размеры учитывают отступы и второй блок.
 * Плюс фиксация при максимально открытом окне.
 * @type {FlattenSimpleInterpolation}
 */
const listItemPhotoCss = css<Props>`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: ${(props) => calculatePosition(props)};
`

export const ListItemPhotoContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
`

export const ListItemPhotoSizer = styled.div`
  padding-top: calc(${IMAGE_RATIO} * 100%);
  height: 100%;
`

export const ListItemPhoto = styled.img<Partial<Props>>`
  ${listItemPhotoCss};
`
export const ListItemInfo = styled.div`
  padding: 10px;
  position: relative;
  background-color: ${Colors.white};
`

export const ProfileNameStyle = styled.div`
  font-size: 16px;
  font-weight: bold;
  margin: 0;
  color: var(--static-black);
`

export const TitleLine = styled.div`
  font-size: 16px;
  font-weight: bold;
  margin: 0;
  color: var(--static-black);
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  transition: color 0.3s ease;
`

export const ListItem = styled.div`
  ${ListItemBaseCss};

  &:hover ${TitleLine} {
    transition: color 0.3s ease;
    color: ${Colors.linkSelected};
  }
`

const textStyle = css`
  font-size: 12px;
  color: ${Colors.location};
  margin: 5px 0 0;
`

export const InfoLocation = styled.p`
  ${textStyle};
`

export const PromoButtonWrapper = styled.div`
  width: 100%;
`

export const PromoText = styled.div`
  margin: 10px 0;
  text-align: center;
  color: var(--static-black);
  font-size: ${FontSize.text}px;

  @media (max-width: ${sizes.minimalSize}px) {
    font-size: ${FontSize.note}px;
  }
`

export const MismatchesList = styled.p`
  ${textStyle};
  position: relative;
  max-height: 43px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
`

export const MismatchesItem = styled.span`
  text-decoration: line-through;

  &:not(:first-child) {
    text-transform: lowercase;
  }
`

export const GridExtend = styled.div`
  & > div > div {
    display: grid !important;
    grid-template-columns: repeat(5, minmax(100px, 1fr));
    gap: ${GRID_GUTTER_WIDE}px !important;

    @media (max-width: 1300px) {
      grid-template-columns: repeat(4, minmax(100px, 1fr));
    }

    @media (max-width: 1280px) {
      grid-template-columns: repeat(3, minmax(100px, 1fr));
    }

    @media (max-width: 690px) {
      grid-template-columns: repeat(2, minmax(100px, 1fr));
    }
  }

  /* stylelint-disable-next-line selector-max-compound-selectors */
  & > div > div > div {
    width: 100% !important;
  }

  /* stylelint-disable-next-line selector-max-compound-selectors */
  & > div > div > div > div {
    margin-bottom: ${GRID_GUTTER_WIDE}px !important;
  }

  @media (max-width: ${sizes.tabletLarge}px) {
    & > div > div {
      gap: ${GRID_GUTTER_SMALL}px !important;
    }

    /* stylelint-disable-next-line selector-max-compound-selectors */
    & > div > div > div > div {
      margin-bottom: ${GRID_GUTTER_SMALL}px !important;
    }
  }
`

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(5, minmax(100px, 1fr));
  grid-gap: ${GRID_GUTTER_WIDE}px ${GRID_GUTTER_WIDE}px;
  grid-auto-rows: min-content;

  @media (max-width: ${sizes.tabletLarge}px) {
    grid-gap: ${GRID_GUTTER_SMALL}px ${GRID_GUTTER_SMALL}px;
  }

  @media (max-width: 1280px) {
    grid-template-columns: repeat(4, minmax(100px, 1fr));
  }

  @media (max-width: 690px) {
    grid-template-columns: repeat(3, minmax(100px, 1fr));
  }

  @media (max-width: 460px) {
    grid-template-columns: repeat(2, minmax(100px, 1fr));
  }
`
